/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { GetExchangeRatesResponse } from '../models/GetExchangeRatesResponse';
import type { UpdateExchangeRateRequest } from '../models/UpdateExchangeRateRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class MonetaryService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @returns any OK
     * @throws ApiError
     */
    public updateThbToMotalExchangeRate({
        requestBody,
    }: {
        requestBody: UpdateExchangeRateRequest,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/v2/monetary/exchange-rate/thb/motal',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public updateMotalToThbExchangeRate({
        requestBody,
    }: {
        requestBody: UpdateExchangeRateRequest,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/v2/monetary/exchange-rate/motal/thb',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public syncUsd(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/v2/monetary/currency/sync',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns GetExchangeRatesResponse OK
     * @throws ApiError
     */
    public getExchangeRates(): CancelablePromise<GetExchangeRatesResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v2/monetary/exchange-rate',
            errors: {
                400: `Bad Request`,
            },
        });
    }
}
